import { API_ENDPOINT } from "@/constants/appConstants";
import { getHttpMethod } from "@/helpers/getHttpMethod";
import { useProfileSectionData } from "@/hooks";
import {
  AI_SUMMARY,
  PROFILE_QUERY_KEY,
  PROFILE_STATS_QUERY_KEY,
  VALIDATE_PROFILE_QUERY_KEY,
} from "@/lib/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ActionType, ErrorResponse } from "@/components/profile/types";
import { WorkExpAPIResponse } from "@/components/profile/workExperience/types";

// export const getWorkExp = (): UseQueryResult<WorkExpAPIResponse, Error> => {
//   return useQuery({
//     queryKey: [WORK_EXPERIENCE_QUERY_KEY],
//     queryFn: () => {
//       return profileAPI<WorkExpAPIResponse>("employments");
//     },
//   });
// };

export const getWorkExp = () => {
  return useProfileSectionData<WorkExpAPIResponse>("employmentDetailSection");
};

export const useUpdateWorkExp = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ data, action }: { data: any; action: ActionType }) => {
      let method = getHttpMethod(action);
      const response = await fetch(
        API_ENDPOINT(window.location.host).middleware.employmentDetails,
        {
          method,
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        const errorData = (await response.json()) as ErrorResponse;
        throw new Error(
          errorData.error.message.errorMessage || "Something went wrong",
        );
      }

      return await response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PROFILE_QUERY_KEY] });
      // queryClient.invalidateQueries({ queryKey: [WORK_EXPERIENCE_QUERY_KEY] });
      // // for updating basic details
      // queryClient.invalidateQueries({ queryKey: [PERSONAL_QUERY_KEY] });
      // // for updating ai summary
      queryClient.invalidateQueries({ queryKey: [AI_SUMMARY] });
      // for updating the profile score
      queryClient.invalidateQueries({ queryKey: [PROFILE_STATS_QUERY_KEY] });
      // for updating the l1 apop action_type
      queryClient.invalidateQueries({ queryKey: [VALIDATE_PROFILE_QUERY_KEY] });
    },
  });
};
